import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const QuickActionMenu = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const quickActions = [
    { label: 'Create Bid', icon: 'FilePlus', path: '/bid-management', action: 'create' },
    { label: 'Add Project', icon: 'FolderPlus', path: '/project-management', action: 'create' },
    { label: 'Assign Resources', icon: 'UserPlus', path: '/resource-management', action: 'assign' },
    { label: 'New Customer', icon: 'UserPlus', path: '/customer-management', action: 'create' }
  ];

  const handleAction = (action) => {
    navigate(action?.path, { state: { action: action?.action } });
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef?.current && !menuRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="quick-action-fab" ref={menuRef}>
      {isOpen && (
        <div className="quick-action-menu">
          {quickActions?.map((action) => (
            <button
              key={action?.label}
              onClick={() => handleAction(action)}
              className="quick-action-item"
            >
              <Icon name={action?.icon} size={18} />
              <span>{action?.label}</span>
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="quick-action-button"
        aria-label="Quick actions"
      >
        <Icon name={isOpen ? 'X' : 'Plus'} size={24} />
      </button>
    </div>
  );
};

export default QuickActionMenu;